import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IChangeTrackingService } from "services/ChangeTrackingService";
import { ChangeTrackingModel, ChangeTrackingTypes } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  ChangeRecords: new ChangeTrackingModel(),
  FilterColumnKey: "",
  FilterString: "",
  Loading: false,
};

export const changeTrackingSlice = createSlice({
  name: "changeTracking",
  initialState,
  reducers: {
    setFilterColumnKey: (state, action) => {
      state.FilterColumnKey = action.payload;
    },
    setFilterString: (state, action) => {
      state.FilterString = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChangeHistory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getChangeHistory.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getChangeHistory.fulfilled, (state, action) => {
        state.ChangeRecords = action.payload;
        state.Loading = false;
      });
  },
});

export const getChangeHistory = createAsyncThunk<ChangeTrackingModel, { type: ChangeTrackingTypes; recordID: string }>(
  "ChangeTracking/GetChangeHistory",
  async ({ type, recordID }) => {
    const changeTrackingService = container.get<IChangeTrackingService>(SERVICE_TYPES.ChangeTrackingService);
    return await changeTrackingService.getChangeHistory(type, recordID);
  }
);

export const { setFilterString, setFilterColumnKey } = changeTrackingSlice.actions;
export const selectChangeRecords = (state: RootState) => {
  return state.changeTracking.ChangeRecords;
};
export const selectFilterColumnKey = (state: RootState) => {
  return state.changeTracking.FilterColumnKey;
};
export const selectFilterString = (state: RootState) => {
  return state.changeTracking.FilterString;
};
export const selectIsLoading = (state: RootState) => {
  return state.changeTracking.Loading;
};

export default changeTrackingSlice.reducer;
